import { DOM } from '@app/utils';
import { client } from '@app/data/iron';

const POST_PORTFOLIO_ITEM = async ({ action, data }) => {
  const token = DOM.getCookie('token');
  const { data: result } = await client.post(
    `/api/portfolio?a=${action}`,
    data,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return result;
};

export default POST_PORTFOLIO_ITEM;
